var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Placeholder } from "@storybook/components";
import { jsx } from "@storybook/theming";
import { Fragment, useMemo } from "react";
import { IFrame } from "./IFrame";
export var v1UrlParser = function (url) {
    if (url.protocol !== "https:") {
        return {
            valid: false,
            error: (jsx(Fragment, null,
                "Expected HTTPS link, received ",
                jsx("code", null, url.protocol),
                ".")),
        };
    }
    if (url.hostname !== "www.sketch.com") {
        return {
            valid: false,
            error: (jsx(Fragment, null,
                "Expected a hostname ",
                jsx("code", null, "www.sketch.com"),
                ", received",
                " ",
                jsx("code", null, url.hostname))),
        };
    }
    var malformedUrlErrorMessage = (jsx(Fragment, null,
        "Expected pathname ",
        jsx("code", null, "/s/<string>/a/<string>"),
        ", received",
        " ",
        jsx("code", null, url.pathname),
        "."));
    var pathSegments = url.pathname.split("/").slice(1);
    if (pathSegments.length < 4) {
        return {
            valid: false,
            error: malformedUrlErrorMessage,
        };
    }
    if (pathSegments[0] === "embed") {
        return {
            valid: true,
            data: {
                url: url.href,
                offscreen: false,
            },
        };
    }
    var s = pathSegments[0], sid = pathSegments[1], a = pathSegments[2], aid = pathSegments[3];
    if (s !== "s" || !sid || a !== "a" || !aid) {
        return {
            valid: false,
            error: malformedUrlErrorMessage,
        };
    }
    return {
        valid: true,
        data: {
            url: "https://www.sketch.com/embed/s/".concat(sid, "/a/").concat(aid),
            offscreen: false,
        },
    };
};
export var Sketch = function (_a) {
    var config = _a.config;
    var result = useMemo(function () {
        var parsed = v1UrlParser(new URL(config.url));
        if (!parsed.valid) {
            return parsed;
        }
        return __assign(__assign({}, parsed), { data: __assign(__assign({}, config), parsed.data) });
    }, [config]);
    if (!result.valid) {
        return (jsx(Placeholder, null,
            jsx(Fragment, null, "Invalid Sketch URL"),
            jsx(Fragment, null, result.error)));
    }
    return jsx(IFrame, { defer: true, config: result.data });
};
